import Hashids from "hashids";
const HASHID_INSTANCES = {
    display: new Hashids("display", 10),
    asset: new Hashids("asset", 20),
};
function ensureInstance(type) {
    if (!HASHID_INSTANCES[type])
        HASHID_INSTANCES[type] = new Hashids(type);
}
export function encodeHashid(type, ...args) {
    ensureInstance(type);
    return HASHID_INSTANCES[type].encode(...args);
}
export function decodeHashid(type, hash) {
    ensureInstance(type);
    return HASHID_INSTANCES[type].decode(hash);
}
//# sourceMappingURL=hashids.js.map